
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","fill":"#9b9b9b","width":"18","height":"18"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M16.071 1.929h-1.928V.643a.643.643 0 10-1.286 0v1.286H5.143V.643a.643.643 0 10-1.286 0v1.286H1.929A1.929 1.929 0 000 3.857v12.214A1.929 1.929 0 001.929 18h14.142A1.929 1.929 0 0018 16.071V3.857a1.929 1.929 0 00-1.929-1.928zm.643 14.143a.643.643 0 01-.643.643H1.929a.643.643 0 01-.643-.643V7.714h15.428zm0-9.643H1.286V3.857a.643.643 0 01.643-.643h1.928V4.5a.643.643 0 101.286 0V3.214h7.714V4.5a.643.643 0 101.286 0V3.214h1.929a.643.643 0 01.643.643v2.572z","fill":"inherit","opacity":".5"}})])
          )
        }
      }
    